import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-black">
      <div className="text-center space-y-4">
        <img
          src="/images/ana_logo.png"
          alt="OpenAna Logo"
          className="mx-auto h-12 w-auto"
        />
        <img
          src="/images/ana_text.svg"
          alt="OpenAna"
          className="mx-auto h-8 w-auto mt-4 dark:hidden"
        />
        <img
          src="/images/ana_text_dark.svg"
          alt="OpenAna"
          className="mx-auto h-8 w-auto mt-4 hidden dark:block"
        />
        <div className="flex items-center justify-center mt-8 bg-white dark:bg-black border border-gray-200 dark:border-[#1F2937] rounded-xl p-4">
          <svg className="animate-spin h-5 w-5 text-[#FF3D00] mr-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="text-gray-900 dark:text-white">Logging you in...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;